<template>
<div class="chapter">
<div class="inner_page">
<p class="centera"><em>A note on the author</em></p>
<p class="para">Angus McAllister worked as a solicitor and university professor, and is now retired. For many years he wrote academic books and articles, as well as fiction. He is the author of <em>The Krugg Syndrome</em>, <em>The Canongate Strangler</em>, <em>The Cyber Puppets</em> and the bestselling <em>Close Quarters</em>, and he lives in Glasgow. See www.angusmcallister.co.uk for more information.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// fm02.vue?4be610dc